type GetCurrencySymbolParams = {
  currencyCode: string;
  locale?: string;
};

export const getCurrencySymbol = ({
  currencyCode,
  locale = navigator.language
}: GetCurrencySymbolParams): string => {
  if (!locale || !currencyCode) {
    return '';
  }

  try {
    return (0)
      .toLocaleString(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
      .replace(/\d/g, '')
      .trim();
  } catch (e) {
    return '';
  }
};

export const isPriceValid = (price: string | number | undefined): boolean => {
  if (!price) {
    return false;
  }

  const numericPrice = typeof price === 'string' ? Number(price) : price;

  return (
    typeof numericPrice === 'number' &&
    !isNaN(numericPrice) &&
    numericPrice > 0 &&
    isFinite(numericPrice)
  );
};

export const isCurrencyValid = (currencyCode: string | undefined): boolean => {
  if (!currencyCode) {
    return false;
  }

  // Validate currency code format (ISO 4217 standard)
  return /^[A-Z]{3}$/.test(currencyCode.trim().toUpperCase());
};
